export const FILE_UPLOAD_MAX_FILE_SIZE = '6MB';
export const FILE_UPLOAD_ALLOWED_FILE_TYPES = [
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.macroFILE_UPLOAD_TIMEOUTabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroenabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/json'
];

export const BOM_FILE_UPLOAD_ALLOWED_FILE_TYPES = [

    'application/json'
];

export const FILE_UPLOAD_ALLOWED_FILE_TYPES_MAPPING_WINDOWS = {
    'txt'  : 'text/plain',
    'zip'  : 'application/zip',
    'xls'  : 'application/vnd.ms-excel',
    'xlsm' : 'application/vnd.ms-excel.sheet.macroEnabled.12',
    'xltm' : 'application/vnd.ms-excel.template.macroEnabled.12',
    'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

export const FILE_UPLOAD_ALLOWED_FILE_TYPES_MAPPING = {
    'txt'  : 'text/plain',
    'zip'  : 'application/zip',
    'xls'  : 'application/vnd.ms-excel',
    'xlsm' : 'application/vnd.ms-excel.sheet.macroenabled.12',
    'xltm' : 'application/vnd.ms-excel.template.macroenabled.12',
    'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

export const FILE_UPLOAD_COMPLETE_MSG = "File accepted – Load is staged for processing!";
export const FILE_UPLOAD_TAP_TO_REMOVE = "tap to remove";
export const FILE_UPLOAD_ICON_UNDO = '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><path d="M11.586 13l-2.293 2.293a1 1 0 0 0 1.414 1.414L13 14.414l2.293 2.293a1 1 0 0 0 1.414-1.414L14.414 13l2.293-2.293a1 1 0 0 0-1.414-1.414L13 11.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L11.586 13z" fill="currentColor" fill-rule="nonzero"/></svg>';
export const FILE_UPLOAD_MAX_PARALLEL_UPLOADS = 10;
export const FILE_UPLOAD_INVALID_FILE_NAME_MSG =
  'File Name should contain only one of the following keyword (Price/ LeadTime / Surcharge / SMC) ie APPricingLoaderPrice_<username>_YYYYMMDD-HHMM.xlsm';
export const FILE_UPLOAD_INVALID_FILE_TYPE_MSG = 'Valid file types ( *.xls, *.xlsx, *.xlsm )';
export const NBY_BOM_FILE_UPLOAD_INVALID_FILE_TYPE_MSG = 'Valid file types ( *.xlsm )';
export const FILE_UPLOAD_INVALID_FILE_SIZE_MSG = 'File size should be less than 6 MB ';
export const FILE_UPLOAD_ALLOWED_FILE_NAME_KEYWORDS = ['price', 'leadtime', 'surcharge', 'smc'];
export const FILE_UPLOAD_MAX_FILES = 10;
export const FILE_UPLOAD_TIMEOUT = 240000;
export const OKTA_PREPROD_HOST = 'nike-qa.oktapreview.com';
export const OKTA_PREPROD_SERVER_ID = 'ausa0mcornpZLi0C40h7';
export const OKTA_PROD_HOST = 'nike.okta.com';
export const OKTA_PROD_SERVER_ID = 'aus27z7p76as9Dz0H1t7';
export const OKTA_CLIENT_ID = 'nike.pes.pcx-data-load-app';

export const FILE_UPLOAD_GET_STATUS_ERROR = "Error while fetching upload history. Try refreshing the screen , if the problem still persists please reach out to support.";

export const REACT_APP_NBY_BOM_ALLOWED_OKTA_GROUP_DEV='LST-PCX.NBY.BOM.Users.Dev';
export const REACT_APP_NBY_BOM_ALLOWED_OKTA_GROUP_PROD='LST-PCX.NBY.BOM.Users.Prod';
export const REACT_APP_AP_PRICE_LOADER_ALLOWED_OKTA_GROUP_DEV='LST-PCX.Loaders.Users.Dev';
export const REACT_APP_AP_PRICE_LOADER_ALLOWED_OKTA_GROUP_PROD='LST-PCX.Loaders.Users.Prod';


export const tfob = {
    statusTableTitle   : "Data Validation Status",
    statusTableMessage : "Files successfully uploaded to PCX will be cleared from the table below after one day. Files that do not successfully upload to PCX will display below and then be cleared after seven days.",
    s3_bucket_prefix   : 'fw-tfob'
};

export const BOM = {
    statusTableTitle   : "Data Validation Status",
    statusTableMessage : "Files successfully uploaded to PCX will be cleared from the table below after one day. Files that do not successfully upload to PCX will display below and then be cleared after seven days.",
    s3_bucket_prefix   : 'fw-tfob'
};
export const nbyBom = {
    statusTableTitle   : "Data Validation Status",
    statusTableMessage : "Files successfully uploaded to PCX will be cleared from the table below after one day. Files that do not successfully upload to PCX will display below and then be cleared after seven days.",
    s3_bucket_prefix   : 'fw-nbyBom'
};

export const apPricing = {
    statusTableTitle   : "Status",
    statusTableMessage : "Successfully uploaded files will be staged for cleanup after a day whereas Error files will be staged for clean up after 7 days.",
    s3_bucket_prefix   : 'ap-pricing'
};

export const bombol = {
    contentType   : "application/json",
    uploadFilesMaxLimit : "10"
    
};

export const CONCURRENCY_ERROR_MESSG = "Unable to upload file since the App reached the maximum limit. Please retry after few seconds.";


